module.exports = __webpack_public_path__ + "static/media/AnthonyTuffour1.0bbff72f.jpg";